<template>
  <main class="plans-page">
    <header class="plans-header">
      <p class="eyebrow">DUE planos</p>
      <h1>Escolha seu ponto de partida no ecossistema</h1>
      <p>
        Cadastro inicial gratuito com evolução por contexto pessoal e
        compartilhado.
      </p>
    </header>

    <section class="plans-grid">
      <article class="plan-card">
        <h2>DUE Start</h2>
        <p class="price">R$ 0,00</p>
        <p>Entrada no ecossistema com cadastro, me e acesso inicial ao us.</p>
      </article>
      <article class="plan-card">
        <h2>DUE One</h2>
        <p class="price">R$ 19,90/mês</p>
        <p>Premium leve para uso individual recorrente.</p>
      </article>
      <article class="plan-card">
        <h2>DUE Plus</h2>
        <p class="price">R$ 49,90/mês</p>
        <p>Uso contínuo em múltiplos fluxos e automações.</p>
      </article>
      <article class="plan-card">
        <h2>DUE Prime</h2>
        <p class="price">R$ 99,90/mês</p>
        <p>Camada premium avançada e experiência cross-module.</p>
      </article>
    </section>

    <footer class="plans-actions">
      <router-link class="btn btn-primary" to="/cadastro">Criar conta DUE</router-link>
      <router-link class="btn btn-secondary" to="/entrar">Entrar</router-link>
      <router-link class="btn btn-ghost" to="/me">Acessar me</router-link>
      <router-link class="btn btn-ghost" to="/us">Acessar us</router-link>
    </footer>
  </main>
</template>

<script>
export default {
  name: 'SitePlans',
};
</script>

<style scoped>
.plans-page {
  max-width: 1080px;
  margin: 120px auto 40px;
  padding: 0 20px;
  color: #13232a;
}

.plans-header {
  background: linear-gradient(140deg, #ecf8fb 0%, #ffffff 70%);
  border-radius: 18px;
  padding: 28px;
  border: 1px solid #dce7ec;
}

.eyebrow {
  margin: 0 0 8px;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
  color: #0f7184;
}

.plans-header h1 {
  margin: 0;
  font-size: 34px;
}

.plans-header p {
  margin: 10px 0 0;
  color: #35505b;
}

.plans-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.plan-card {
  border: 1px solid #dce7ec;
  border-radius: 14px;
  padding: 20px;
  background: #fff;
}

.plan-card h2 {
  margin: 0;
}

.price {
  margin: 8px 0;
  font-size: 24px;
  font-weight: 700;
}

.plan-card p {
  margin: 0;
  color: #35505b;
}

.plans-actions {
  margin-top: 18px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 11px 15px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 700;
}

.btn-primary {
  background: #0a7e90;
  color: #fff;
}

.btn-secondary {
  background: #122d38;
  color: #fff;
}

.btn-ghost {
  background: #f3f8fa;
  color: #122d38;
}

@media (max-width: 900px) {
  .plans-page {
    margin-top: 112px;
    padding: 0 14px 20px;
  }

  .plans-header h1 {
    font-size: 28px;
  }

  .plans-grid {
    grid-template-columns: 1fr;
  }
}
</style>
